import gql from 'graphql-tag';

const InitiateWearableConnectionMutation = gql`
  mutation InitiateWearableConnection($provider: String!, $redirectUri: String!) {
    wearable {
      initiateConnection(provider: $provider, redirectUri: $redirectUri) {
        ... on InitiateWearableConnectionSuccess {
          code
          authorizationUrl
        }
        ... on Error {
          name
          description
        }
      }
    }
  }
`;

export default InitiateWearableConnectionMutation;
